<template>
  <div class="history">
    <span class="font-red">Each documents will be available for re-download for 72 hours, just click Re-download</span>
    <el-tabs v-model="currentValue" class="tabs-list" >
      <el-tab-pane
        v-for="(o,oIndex) in tabList"
        :key="oIndex"
        :label="o.label"
        :name="o.name"
        class="tabs-content"
        v-loading="tableLoading">
        <Table :obj="o.data" @sizeChange="sizeChange" @pageChange="pageChange" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Table from "./module/table.vue";
import { getConsumeList } from "../../api/order";
export default {
  components: {
    Table
  },
  data() {
    return {
      currentValue: "first",
      tabList: [
        {
          label: "History",
          name: "first",
          data: {}
        }
      ],
      tableLoading: false,
      pageNo:1,
      pageSize:10
    };
  },
  mounted() {
    this.getTableDatas();
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-78962210-9');
  },
  methods: {
    getTableDatas() {
      this.tableLoading = true;
      this.tabList.forEach((item, index) => {
        let dataform = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orderType: index + 1
        };
        getConsumeList(dataform).then(result => {
            this.tableLoading = false;
            item.data = result;
          }).catch(error => {
            this.tableLoading = false;
            console.log(JSON.stringify(error));
          });
      });
    },
    pageChange(params){
      this.pageNo = params;
      this.pageSize = 10;
      this.getTableDatas();
    },
    sizeChange(param){
      this.pageSize = param;
      this.pageNo = 1;
      this.getTableDatas();
    }
  }
};
</script>

<style lang="scss" scoped>
  .font-red {
    color: #909399;
    float: right;
    margin-top: 12px;
  }
</style>
